(function () {
  var DUMMY_TAG = 'dummy-product';
  var productCache = {};
  var processing = false;

  function shopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function cartJsUrl() {
    return shopRoot().replace(/\/?$/, '/') + 'cart.js';
  }

  function productJsUrl(handle) {
    return shopRoot().replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function cartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) || shopRoot().replace(/\/?$/, '/') + 'cart/update.js';
  }

  function checkoutUrl() {
    return shopRoot().replace(/\/?$/, '/') + 'checkout';
  }

  function cartPageUrl() {
    return (window.routes && window.routes.cart_url) || shopRoot().replace(/\/?$/, '/') + 'cart';
  }

  function hasDummyTag(tags) {
    if (!tags) return false;
    var list = Array.isArray(tags) ? tags : String(tags).split(',');
    return list.some(function (tag) {
      return String(tag).toLowerCase().trim() === DUMMY_TAG;
    });
  }

  function isDummyItem(item, product) {
    var type = String((item && item.product_type) || '')
      .toLowerCase()
      .trim();
    if (type === 'dummy') return true;

    var props = (item && item.properties) || {};
    if (props._dummy_product === 'true' || props._dummy_product === true) return true;

    if (hasDummyTag(item && item.tags)) return true;
    if (product && hasDummyTag(product.tags)) return true;

    return false;
  }

  function setCheckoutBusy(busy) {
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(function (btn) {
      btn.disabled = busy;
      if (busy) {
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('aria-busy');
      }
    });
  }

  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);

    return fetch(productJsUrl(handle), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (data) {
        if (data) productCache[handle] = data;
        return data;
      })
      .catch(function () {
        return null;
      });
  }

  function removeDummyThenCheckout() {
    if (processing) return Promise.resolve();
    processing = true;
    setCheckoutBusy(true);

    return fetch(cartJsUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        if (!items.length) {
          window.location.href = cartPageUrl();
          return null;
        }

        return Promise.all(
          items.map(function (item) {
            return getProduct(item.handle).then(function (product) {
              return { item: item, dummy: isDummyItem(item, product) };
            });
          })
        );
      })
      .then(function (classified) {
        if (!classified) return null;

        var dummyItems = classified.filter(function (entry) {
          return entry.dummy;
        });

        if (!dummyItems.length) {
          window.location.href = checkoutUrl();
          return null;
        }

        var updates = {};
        dummyItems.forEach(function (entry) {
          updates[entry.item.key] = 0;
        });

        var remainingCount = classified.length - dummyItems.length;

        return fetch(cartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ updates: updates }),
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          if (remainingCount < 1) {
            window.location.href = cartPageUrl();
            return;
          }
          window.location.href = checkoutUrl();
        });
      })
      .catch(function (error) {
        console.error('Dummy product checkout cleanup failed', error);
        processing = false;
        setCheckoutBusy(false);
      });
  }

  function eventIsCheckoutIntent(event) {
    var path = event.composedPath ? event.composedPath() : [];
    if (!path.length && event.target) path = [event.target];

    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || node.nodeType !== 1) continue;
      if (node.matches && node.matches('button[name="checkout"], input[name="checkout"]')) return true;
      if (
        node.matches &&
        node.matches('.additional-checkout-buttons, .cart__dynamic-checkout-buttons, shopify-accelerated-checkout')
      ) {
        return true;
      }
    }
    return false;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!eventIsCheckoutIntent(event)) return;
      event.preventDefault();
      event.stopPropagation();
      removeDummyThenCheckout();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var submitter = event.submitter;
      var checkoutSubmit = !!(submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout');

      if (!checkoutSubmit && !(form && form.id === 'cart-notification-form')) return;

      event.preventDefault();
      event.stopPropagation();
      removeDummyThenCheckout();
    },
    true
  );
})();
